import { debounce, toValidCssIdentifier } from '../util';

$(() => {
    const bookHitList = document.querySelector('#hitlist');
    const bookFilterForm = document.querySelector('#bookFilterForm');
    const bookFilterSelected = document.querySelector('#bookFilterForm-selected');

    if (!bookHitList || !bookFilterForm) return;

    let isFetching = false;

    const checkDropdownFilters = (facetGroups) => {
        facetGroups.forEach((facetGroup) => {
            let fieldsetElement = document.querySelector(
                `.multiple-select-input[data-facet-id="${facetGroup.facetIdentifier}"]`
            );

            if (!fieldsetElement) return;

            if (facetGroup.FacetValues.length == 0) {
                fieldsetElement.classList.add('d-none');
            } else {
                if (!fieldsetElement) return;

                let listElement = fieldsetElement.querySelector('.multiple-select-input--list');

                if (!listElement) return;

                listElement.innerHTML = '';

                facetGroup.FacetValues.forEach((facetValue) => {
                    let listItem = document.createElement('li');
                    listItem.classList.add('multiple-select-input--item');

                    let input = document.createElement('input');
                    input.classList.add('js-facet-checkbox');
                    input.type = 'checkbox';
                    input.id = `${facetGroup.facetIdentifier}_${toValidCssIdentifier(facetValue.Name)}`;
                    input.name = facetGroup.facetIdentifier;
                    input.value = facetValue.Name;
                    input.checked = facetValue.IsSelected;

                    let label = document.createElement('label');
                    label.htmlFor = `${facetGroup.facetIdentifier}_${toValidCssIdentifier(facetValue.Name)}`;
                    label.innerText = facetValue.Name;

                    listItem.appendChild(input);
                    listItem.appendChild(label);

                    listElement.appendChild(listItem);
                });

                fieldsetElement.classList.remove('d-none');
            }
        });
    };

    const getBookHits = () => {
        if (isFetching) return;

        isFetching = true;

        const formData = new FormData(bookFilterForm);
        const searchParams = new URLSearchParams(formData).toString();

        fetch(bookFilterForm.getAttribute('action') + '?' + searchParams, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                bookHitList.innerHTML = data.hitsHtml;
                bookFilterSelected.innerHTML = data.bookFilterSelectedHtml;
                checkDropdownFilters(data.facets);
                isFetching = false;
                window.history.replaceState(null, null, '?' + searchParams);
            });
    };

    const getBookHitsDebounced = debounce(getBookHits, 250);

    bookFilterForm.addEventListener('submit', function (event) {
        event.preventDefault();

        getBookHitsDebounced();
    });

    $('body').on('click', '.multiple-select-input label', (event) => {
        getBookHitsDebounced();
    });

    $('body').on('keydown', '.multiple-select-input input[type="checkbox"]', (event) => {
        if (event.key === ' ') {
            getBookHitsDebounced();
        }
    });

    $('body').on('click', '.selected-item-chip.js-remove-specific', (event) => {
        const { referenceId, type } = event.target.dataset;

        if (type === 'ix') {
            $('input[name="letter"]').val('');
        } else if (type === 'queryString') {
            $(`#${referenceId}`).val('');
        } else {
            $(`#${referenceId}`).prop('checked', false);
        }

        getBookHitsDebounced();
    });

    $('body').on('click', '.selected-item-chip.js-remove-all', (event) => {
        $('.js-facet-checkbox').prop('checked', false);

        $('input[name="letter"]').val('');

        $('#search-product-input').val('');

        getBookHitsDebounced();
    });
});
